import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: {
        data: [],
        page: 1,
        total: 1,
        loading: false
    },
    saveSuccess: false,
    loadingSave: false,
    newCreateId: null,
    errors: {}
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.POSTBACK_SEARCH_START_LOADING:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: true
                }
            };

        case AppConstants.POSTBACK_SEARCH_LOAD_SUCCESS:
            return {
                ...state,
                list: {
                    data: action.items.items,
                    page: action.items.page,
                    total: getTotalPages(action.items.total, action.items.count),
                    loading: false
                }
            };

        case AppConstants.POSTBACK_CLEAR_ERROR:
            return {
                ...state,
                errors: {}
            };

        case AppConstants.POSTBACK_SAVE_START_LOADING:
            return {
                ...state,
                saveSuccess: false,
                loadingSave: true,
                errors: {}
            };

        case AppConstants.POSTBACK_SAVE_SUCCESS:
            return {
                ...state,
                newCreateId: action.id,
                saveSuccess: true,
                loadingSave: false,
                errors: {}
            };

        case AppConstants.POSTBACK_EDIT_SUCCESS:
            return {
                ...state,
                saveSuccess: true,
                loadingSave: false,
                errors: {}
            };

        case AppConstants.POSTBACK_SAVE_FAIL:
            return {
                ...state,
                loadingSave: false,
                saveSuccess: false,
                errors: action.error.invalid_parameters
            };

        default:
            return state;
    }
};
